<template>
  <div>
    <Item
      :class="['fapi-form-item', 'fapi-form-item-' + index]"
      v-for="(item, index) in itemGroup.items"
      :item="item"
      :currency="currency"
      :last="index === itemGroup.items.length - 1"
      :isFirst="index === 0"
      :itemGroup="itemGroup"
      :showPricesIncludingVat="showPricesIncludingVat"
      :renderLikeRadio="renderLikeRadio"
      :isVatPayer="isVatPayer"
      :selectedPeriod="selectedPeriod"
      :selectedRadioId="selectedRadioId"
      :formResource="formResource"
      v-bind:key="item.id + '-item'"
      @itemDataChanged="$emit('itemDataChanged', $event)"
      @selectRadio="selectRadio"
    ></Item>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import Item from "@/components/Form/Items/Item.vue";
import FormItemGroup from "@/module/FormItemGroup";
import SelectedItem from "@/module/Form/SelectedItem";
import FormResource from "@/module/Form/Resources/FormResource";
import { isStringOrNull } from "@/module/ComponentPropsValidations/validations";

interface ComponentData {
  selectedRadioId: number | null;
}

export default Vue.extend({
  name: "Items",

  components: { Item },

  props: {
    itemGroup: {
      type: Object as PropType<FormItemGroup>,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    showPricesIncludingVat: {
      type: Boolean,
      required: true,
    },
    renderLikeRadio: {
      type: Boolean,
      required: true,
    },
    selectedItems: {
      type: Array as PropType<Array<SelectedItem>>,
      required: true,
    },
    isVatPayer: {
      type: Boolean,
      required: true,
    },
    selectedPeriod: {
      required: true,
      validator: isStringOrNull,
    },
    formResource: {
      type: Object as PropType<FormResource>,
      required: true,
    },
  },

  data(): ComponentData {
    return {
      selectedRadioId: null,
    };
  },

  methods: {
    selectRadio(data: { id: number }): void {
      this.selectedRadioId = data.id;
    },
  },
});
</script>
